import React from 'react';
import { useTranslation } from 'react-i18next';

const ObservationComponent = ({ report, beta }) => {
  const { t } = useTranslation();

  if (!report.observation_type) {
    return null;
  }

  return (
    <div className="further-details">
      {beta && <div className="border-b my-4 border-[#F4F5F7]" />}
      <h2>Further Details</h2>
      <table>
        <tbody>
          <tr>
            <th>Observation Type</th>
            <td>{t(`observation.${report.observation_type.toLowerCase()}`)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default ObservationComponent;
